const initialState = {
  eventData: {},
  savedEventData: {},
  venueList: [],
  cityList: [],
  isEventImageUploading: false,
};

export default (state = initialState, action) => {
  const { type, data } = action;

  switch(type) {
  case 'ADMIN_EVENT_CREATE:EVENT_DATA:SET':
    return {
      ...state,
      eventData: data,
    };
  case 'ADMIN_EVENT_CREATE:SAVED_EVENT_DATA:SET':
    return {
      ...state,
      savedEventData: data,
    };
  case 'ADMIN_EVENT_CREATE:VENUE_LIST:SET':
    return {
      ...state,
      venueList: data,
    };
  case 'ADMIN_EVENT_CREATE:CITY_LIST:SET':
    return {
      ...state,
      cityList: data,
    };
  case 'ADMIN_EVENT_CREATE:IS_IMAGE_UPLOADING:SET':
    return {
      ...state,
      isEventImageUploading: data,
    };
  case 'ADMIN_EVENT_CREATE:RESET':
    return {
      ...state,
      ...initialState,
    };
  default:
    return state;
  }
}